// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3ypc8","info":"Note_info__1lfyf","note":"Note_note__3rjE3","actions":"Note_actions__1q_7a"};